<div class="renderer" [class.renderer--fallback]="isFallback()" [class.renderer--stack]="isStackLayout()"
    [class.renderer--relative]="isRelativeLayout()"
    [style.background-color]="payload().containerStyle?.backgroundColor"
    [style.font-family]="payload().containerStyle?.fontFamily"
    [style.color]="payload().containerStyle?.color"
    [style.padding]="payload().containerStyle?.padding">
    @if (isFallback() && payload().fallbackImageUrl) {
    <div class="layer-fallback" [style.background-image]="'url(' + payload().fallbackImageUrl + ')'"></div>
    } @else {
    @for (layer of sortedLayers(); track layer.layerKey ?? layer.zIndex) {
    <app-layer [layer]="layer" [layoutStyle]="payload().layoutStyle ?? 'Stack'" />
    }
    }
</div>